	<div class="alinhar-itens">
		@if (!estadosDaPesquisa.registrosEncontrados && !estadosDaPesquisa.pesquisaPronta) {
		<mat-spinner class="spinner-align" mode="indeterminate">
		</mat-spinner>
		}
	</div>
  @if (estadosDaPesquisa.registrosEncontrados && estadosDaPesquisa.pesquisaPronta) {
  <div>
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav class="sidenav" [mode]="sideMenuMode" [(opened)]="filtroLateralAberto">
        <app-filtro-lateral [listaMarcados]="listaMarcados" [listaIdsOriginais]="listaIdsOriginais"
          (idsFiltradosEmitter)="aplicarRemoverFiltros($event)"></app-filtro-lateral>
      </mat-sidenav>
      <mat-sidenav-content class="sidenav-content">
        @if (getLayoutEmUso() === 2 && estadosDaPesquisa.pesquisaPronta) {
        <div>
          <div>
            <app-card-lista-itens [listaItens]="listaItens" [ids]="idsPesquisados" [page]="page" [pagesize]="pageSize">
            </app-card-lista-itens>
          </div>
        </div>
        }
        @if (getLayoutEmUso() === 1 && estadosDaPesquisa.pesquisaPronta) {
        <div>
          <div>
            <app-lista-itens [listaItens]="listaItens" [ids]="idsPesquisados" [page]="page" [pagesize]="pageSize">
            </app-lista-itens>
          </div>
        </div>
        }
        @if (pagination && estadosDaPesquisa.registrosEncontrados && estadosDaPesquisa.pesquisaPronta) {
        <div>
          <div class="paginacao-align">
            <pagination-controls (pageChange)="onEnd($event)" previousLabel="" nextLabel=""></pagination-controls>
          </div>
        </div>
        }
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
  }
